import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = (props) => {
  const {
    title = "LuxRock Realty | Premium Real Estate Property in India",
    description = "LuxRock Realty helps you buy, sell and invest in premium residential and commercial properties with trusted guidance and verified listings.",
    keywords = "real estate, property in india, buy flat, commercial property, property investment, LuxRock Realty",
    url = window.location.origin + window.location.pathname,
    image = "/logo.png",
  } = props;

  const canonicalUrl =
    url.length > 1 && url.endsWith("/") ? url.slice(0, -1) : url;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
